import React, { useState } from 'react';
import { csrfParamToken } from '../../../../../jobs_page/src/utils/utils'

export type StateZipFormProps = {
  countryPlaceholders: Record<string, string>;
  nearmeFormAction: string;
  cta: string;
  country: string;
  className: string;
};

export const StateZipForm = ({
  nearmeFormAction,
  cta,
  country,
  countryPlaceholders,
  className
}: StateZipFormProps) => {
  const { param, token } = csrfParamToken();

  return (
    <div className={`lg:mt-12 flex items-center ${className}`}>
      <form action={nearmeFormAction} acceptCharset="UTF-8" method="post" className="flex flex-wrap items-center justify-start text-sm lg:text-base">
        <input
          className="py-3 pl-7 pr-14 mr-3 mb-3 border border-kale-light bg-cashew rounded-full"
          type="text"
          name="zipcode"
          placeholder={countryPlaceholders[country]}
        />
        {param && token && (
          <input type="hidden" name={param} value={token} />
        )}
        <input type="hidden" name="commit" value="Search" />
        <button className="py-3 px-7 mb-3 bg-kale text-cashew rounded-full" type="submit" value={cta}>{cta}</button>
      </form>
    </div>
  );
};
